/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface SmsTimelineSendRequest {
  /** Message body to process through the inbound SMS path */
  message: string;
}
